export default __webpack_public_path__ + "assets/STROMMAST_OHNE_NETZ_UND_OHNE_SCHRAUBEN.glb";